export const GET_USERINFO = 'GET_USERINFO'
export const UPDATE_USERINFO = 'UPDATE_USERINFO'
